import { stateOptions } from "@/lib/constants";

export const locations = {

  /**
   * Break a duration in seconds into hours and minutes components.
   */
  calculateCommuteDuration: (seconds: number): { hours: number; minutes: number } => {
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);
    if (minutes === 60) {
      hours += 1;
      minutes = 0;
    }
    return { hours, minutes };
  },

  /**
   * Short commute label, e.g. "2h 15m", "1h", or "45 min".
   */
  formatCommuteDuration: (seconds: number): string => {
    const { hours, minutes } = locations.calculateCommuteDuration(seconds);
    if (hours > 0) {
      return minutes > 0
        ? `${hours.toString()}h ${minutes.toString()}m`
        : `${hours.toString()}h`;
    }
    return `${minutes.toString()} min`;
  },

  stripCountrySuffix: (location: string): string => {
    if (!location) return location;
    return location.replace(/, USA$/, "");
  },

  /**
   * Validate a proper format of location (City, State, USA or State, USA) has been entered.
   */
  validateLocation: ({
    enforceFullLocation,
    location,
  }: {
    enforceFullLocation: boolean;
    location: string;
  }): boolean => {
    if (enforceFullLocation) {
      return (
        /^[A-Za-z\s.'-]+,\s[A-Z]{2},\sUSA$/.test(location) &&
        locations.validateState(location.split(",")[1].trim())
      );
    }

    if (!location || location === "Various") return true;

    const locationRegex =
      /^(?:[A-Za-z\s.'-]+,\s[A-Z]{2},\sUSA|[A-Za-z\s]+,\sUSA)$/;

    if (!locationRegex.test(location)) return false;

    // For a (City, State, USA) format, check for state code.
    const locationParts = location.split(",");
    const state =
      locationParts.length > 2
        ? locationParts[1].trim()
        : locationParts[0].trim();

    if (!locations.validateState(state)) return false;

    return true;
  },

  validateState: (state: string): boolean => {
    return stateOptions.some((stateOption) => stateOption.value === state);
  },
};
